export const DIRECTION = {
  NEXT: 'NEXT',
  PREVIOUS: 'PREVIOUS',
} as const
